import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import BaseBadge from 'atoms/base/BaseBadge';
import BaseButton from 'atoms/base/BaseButton';

import ProjectLogo from 'molecules/project/ProjectLogo';

import HeaderMenuList from 'organisms/application/header/HeaderMenuList';
import HeaderDropdownMenu from 'organisms/application/header/HeaderDropdownMenu';

export default {
  props: {
    merchant: {
      type: Object,
      required: true,
    },
    projects: {
      type: Array,
      required: true,
    },
    useSelfEmployed: Boolean,
    notificationsCount: Number,
  },
  components: {
    BaseBadge,
    BaseButton,
    ProjectLogo,
    HeaderMenuList,
    HeaderDropdownMenu,
  },
  data() {
    return {
      isMenuVisibility: false,
    };
  },
  watch: {
    isMenuVisibility: {
      handler(val) {
        if (val) {
          disableBodyScroll(document.body);
        } else {
          enableBodyScroll(document.body);
        }
      },
    },
  },
  methods: {
    isActiveRoute(route) {
      return route === this.$route.name;
    },
    isActiveProject(project) {
      return Number(project.projectId) === Number(this.merchant.currentProjectId);
    },
  },
};
